export default __webpack_public_path__ + "static/media/rounded-exclamation.35a43ead.svg";